import React from 'react';
import styled from 'styled-components'
import PropTypes from "prop-types"
import { media } from '../styles/Mixin';


const getDeskSize = size => {
  let number;
  if (size === "sm") {
    number = 20
  } else if (size === "s_md") {
    number = 25
  } else if (size === "m_md") {
    number = 30
  } else if (size === "l_md") {
    number = 35
  } else if (size === "lg") {
    number = 40
  }
  return `
        width:${number}px;
        height:${number}px;
    `;
}
const getMobileSize = size => {
  let number;
  if (size === "sm") {
    number = 16
  } else if (size === "s_md") {
    number = 20
  } else if (size === "m_md") {
    number = 24
  } else if (size === "l_md") {
    number = 28
  } else if (size === "lg") {
    number = 32
  }
  return `
        width:${number}px;
        height:${number}px;
    `;
}


const CheckBox = ({
  checked,
  size = "sm",
  onClick
})=>{

  return(
    <Wrapper checked={checked} size={size} onClick={onClick} >
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </Wrapper>
  )
}

CheckBox.propTypes = {
  checked:PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['sm', 's_md', 'm_md', 'l_md', 'lg'])
}


export default CheckBox

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`

const Wrapper = styled.div`
    cursor:pointer;
    ${media.deskTop`
    ${props => getDeskSize(props.size)};
    ${props => props.checked ? props.theme.desk_checked_boxBorder : props.theme.desk_dark_boxBorder}
    `};
    ${media.mobile`
    ${props => getMobileSize(props.size)}
    ${props => props.checked ? props.theme.mobile_checked_boxBorder : props.theme.mobile_dark_boxBorder}
    `};
     ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')}
  }
    background-color:${props => props.checked && props.theme.blueColor};
    
`

